import { render } from "./ImportWizard.vue?vue&type=template&id=587136a6"
import script from "./ImportWizard.vue?vue&type=script&lang=js"
export * from "./ImportWizard.vue?vue&type=script&lang=js"

import "./ImportWizard.vue?vue&type=style&index=0&id=587136a6&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__